// extracted by mini-css-extract-plugin
module.exports = {"close_btn":"nieuweKlant_close_btn__11QaI","p_top":"nieuweKlant_p_top__3vZyj","modal_footer":"nieuweKlant_modal_footer__1ysyh"};